import { WebglSettingsConverter } from "./webgl-settings-converter";

export class VisualizatorWebglSettingsConverter extends WebglSettingsConverter {
  constructor(viewWebglSettingsConverter) {
    super();
    this.viewWebglSettingsConverter = viewWebglSettingsConverter;
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    settingsCopy.view = this.viewWebglSettingsConverter.convert(settings.view);
    return settingsCopy;
  }
}
